export function BootingScreen() {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#fafafa',
      }}
    >
      <span style={{ fontSize: '14px', color: '#888' }}>Loading…</span>
    </div>
  );
}
